/**
 * Path-based tenancy helpers.
 *
 * Live:   https://wiztasks.wizcode.lk/w/<slug>/...        deploy sub-path = ""
 * XAMPP:  http://localhost/wiztasks/w/<slug>/...          deploy sub-path = "/wiztasks"
 * ng serve: http://localhost:4200/w/<slug>/...            deploy sub-path = ""
 */

const SLUG = '([a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)';

/** The fixed deploy sub-path (e.g. "/wiztasks" under XAMPP), or "" at a domain root. */
export function deploySubPath(pathname = safePathname()): string {
  return pathname === '/wiztasks' || pathname.startsWith('/wiztasks/') ? '/wiztasks' : '';
}

/** The <slug> from .../w/<slug>/..., or null. */
export function tenantSlugFromPath(pathname = safePathname()): string | null {
  const rest = pathname.slice(deploySubPath(pathname).length) || '/';
  const m = new RegExp(`^/w/${SLUG}(?=/|$)`, 'i').exec(rest);
  return m ? m[1].toLowerCase() : null;
}

/** Router base href: "<sub>/w/<slug>/" inside a workspace, else "<sub>/" or "/". */
export function tenantBaseHref(pathname = safePathname()): string {
  const sub = deploySubPath(pathname);
  const slug = tenantSlugFromPath(pathname);
  if (slug) return `${sub}/w/${slug}/`;
  return sub ? `${sub}/` : '/';
}

/** Absolute URL for a workspace's inner path. */
export function workspaceUrl(slug: string, innerPath = '/dashboard'): string {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const sub = deploySubPath();
  const clean = innerPath.startsWith('/') ? innerPath : `/${innerPath}`;
  return `${origin}${sub}/w/${encodeURIComponent(slug)}${clean}`;
}

/** Absolute URL of the bare-domain workspace picker (no /w/<slug> prefix). */
export function pickerUrl(inner = '/workspaces'): string {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const sub = deploySubPath();
  const clean = inner.startsWith('/') ? inner : `/${inner}`;
  return `${origin}${sub}${clean}`;
}

function safePathname(): string {
  return typeof window !== 'undefined' ? window.location.pathname || '/' : '/';
}
